import React from 'react'
import { AppContainer, Header } from '@templatean/shared/components'
import DesignAssistant from '../components/DesignAssistant'

const DesignStudioPage: React.FC = () => {
  return (
    <AppContainer>
      <Header 
        title="Design Studio"
        subtitle="Themes, colors, and brand consistency"
      />
      
      <div className="page-content">
        <DesignAssistant />
      </div>
    </AppContainer>
  )
}

export default DesignStudioPage